var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBurstMode = function SvgBurstMode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.40002 19V5H2.60002V19H1.40002ZM5.40002 19V5H6.60002V19H5.40002ZM10.6 6.6V17.4H21.4V6.6H10.6ZM9.40002 6.1C9.40002 5.7134 9.71343 5.4 10.1 5.4H21.9C22.2866 5.4 22.6 5.71341 22.6 6.1V17.9C22.6 18.2866 22.2866 18.6 21.9 18.6H10.1C9.71342 18.6 9.40002 18.2866 9.40002 17.9V6.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 16L15.2 12L17.1429 14.5455L18 13.4545L20 16H16H12Z"
  })));
};
export default SvgBurstMode;